import React from 'react'
import '../MainSection.css';
import { Link } from 'react-router-dom';

const AssetCard = ({asset}) => {
    return (
        <div className="col-md-5 shadow-lg card d-flex flex-column align-items-center justify-content-between asset-card-box">
            <div className="asset__logo__container text-center">
                <img src={asset.image} alt="logo"/>
            </div>
            <h4 className="my-4 text-center">{asset.title}</h4>
            <p className='text-center'>
                {asset.excerpt}
            </p>
            <button className="btn btn-primary">
                    <Link to={asset.link}>
                        Explore
                    </Link>
            </button>
        </div>
    )
}

export default AssetCard
